<script>
    export let footerData;
</script>

<div class="footer-wrapper">
    {#if footerData.links}
        <div class="footer-actions">
            {#each footerData.links as link, i}
                <a on:click|stopPropagation href={link.url}>
                    <i class="{link.icon} fa-2x" title={link.title} />
                </a>
            {/each}
        </div>
    {/if}
    {#if footerData.text}
        <div class="overline-text secondary-text-color">{footerData.text}</div>
    {/if}
</div>

<style>
    .footer-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
        align-items: center;
        justify-content: center;
    }

    .footer-actions {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 50%;
    }

    a {
        color: #499167;
    }

    a:hover {
        animation: bounce 0.4s ease-out forwards;
    }
</style>
